// extracted by mini-css-extract-plugin
export default {"link":"oK-z","disabled":"pK-z"};